export default __webpack_public_path__ + "static/jaqueta-cone-medidas-3eb2043561eeb8b62cdeb852c00574d7.png";